exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".has-items[data-count][data-v-5c4573b0]{position:relative}.has-items[data-count][data-v-5c4573b0]:after{position:absolute;top:0;left:.625rem;height:1.25rem;width:auto;place-content:center;border-radius:9999px;border-left-width:2px;border-color:var(--leonard-white);background-color:var(--leonard-green);font-size:.75rem;line-height:1rem;color:var(--leonard-white);aspect-ratio:1/1;content:attr(data-count)}", ""]);

// exports
